import { Space, Radio, Checkbox, Input, Select, Button, Card, message, Steps, DatePicker,} from 'antd'
import React, {useState} from 'react'
import PageHeading from '../../../../../../components/common/PageHeading'
import TopBack from '../../../../../../components/common/TopBack'
import { eligibleCharge, numberOfDaysInMonth } from '../../../../../../utils/NewPropertyHelper';


function LateFeePolicy() {

    let name = "Tenant"

    const [policyWalkThrough, setPolicyWalkThrough] = useState(false)

    const [lateFeeType, setLateFeeType] = useState(1)  
    const [gracePeriod, setGracePeriod] = useState(1)
    const [walkThroughLateFeeType, setwalkThroughLateFeeType] = useState(1)

    const [chargeDailyLateFee, setChargeDailyLateFee] = useState(false)
    const [calculatePercentageFrom, setCalculatePercentageFrom] = useState(1)
    const [gracePeriodLenght, setGracePeriodLenght] = useState(1)

    const [dailyLateFee, setDailyLateFee] = useState(false);
    const [graceBalance, setGraceBalance] = useState(false)

    const LateFeeTypeContent = () => {
        return (
            <>
                <h2>Step 1: Select your late fee type</h2>
                <p style={{ marginTop: 12 }}>First, let's set up your late fee type. Do you charge a flat fee or a percentage?</p>
                <Radio.Group onChange={(e) => { setwalkThroughLateFeeType(e.target.value) }} value={walkThroughLateFeeType} initalvalues={1} style={{ marginTop: 22 }}>
                    <Space direction="vertical">
                        <Radio value={1} style={{ marginTop: 12 }}>I charge a flat fee of {walkThroughLateFeeType === 1 ? <Input style={{ width: 100, marginLeft: 10, marginRight: 10 }} prefix="$" /> : <Input style={{ width: 100, marginLeft: 10, marginRight: 10 }} prefix="$" disabled />}</Radio>
                        <Radio value={2} style={{ marginTop: 12 }}>I charge {walkThroughLateFeeType === 2 ? <Input style={{ width: 100, marginLeft: 10, marginRight: 10 }} suffix="%" /> : <Input style={{ width: 100, marginLeft: 10, marginRight: 10 }} suffix="%" disabled />}</Radio>
                    </Space>
                </Radio.Group>
            </>
        )
    }

    const EligibleChargesContent = () => {
        return (
            <>
                <h2>Step 2: Select which charges get late fees</h2>
                <p style={{ marginTop: 12 }}>So, you're charging a late fee of $0.00. What charges do you want to apply that to?</p>
                <Radio.Group name="radiogroup" >
                    <Space direction="vertical">
                        <Radio value={1} style={{ marginTop: 12 }}>Every charge, except any fromexempt GL accounts</Radio>
                        <Radio value={2} style={{ marginTop: 12 }}>All recurring charges</Radio>
                        <Radio value={3} style={{ marginTop: 12 }}>Only recurring rent</Radio>
                    </Space>
                </Radio.Group>
            </>
        )
    }

    const GracePeriodLengthContent = () => {
        return (
            <>
                <h2>Step 3: Set your grace period length</h2>
                <p style={{ marginTop: 12 }}>For this policy, how long is your grace period?</p>
                <Radio.Group onChange={(e) => { setGracePeriodLenght(e.target.value) }} value={gracePeriodLenght} initalvalues={1} style={{ marginTop: 22 }}>
                    <Space direction="vertical">
                        <Radio value={1}>Tenants have {gracePeriodLenght === 1 ? <Input style={{ width: 100, marginLeft: 10, marginRight: 10 }} prefix="$" /> : <Input style={{ width: 100, marginLeft: 10, marginRight: 10 }} prefix="$" disabled />} days until they are charged a late fee.</Radio>
                        <Radio value={2} style={{ marginTop: 12 }}>Tenants have until day {gracePeriodLenght === 2 ? <Select style={{ width: 100, marginLeft: 10, marginRight: 10 }} options={numberOfDaysInMonth} defaultValue={numberOfDaysInMonth[0]} /> :
                            <Select style={{ width: 100, marginLeft: 10, marginRight: 10 }} options={numberOfDaysInMonth} disabled />} of the following month until they are charged a late fee.</Radio>
                        <Radio value={3} style={{ marginTop: 12 }}>Tenants have no grace period.</Radio>
                    </Space>
                </Radio.Group>

            </>
        )
    }

    const EffectiveDateContent = () => {
        return (
            <>
                <h2>Step 4: Choose when the policy will begin.</h2>
                <p style={{ marginTop: 12 }}>When do you want this policy to start?</p>
                <p style={{ marginTop: 12 }}>These settings affect charges posted on <DatePicker /> and onward. </p>
                

            </>
        )
    }

    const handleDailyLateFee = (e) => {
        setDailyLateFee(e.target.checked);
    }
    const handleGraceBalance = (e) => {
        setGraceBalance(e.target.checked);
    };

    const OptionalSettingsContent = () => {
        return (
            <>
                <h2>Step 4: Choose any optional setting that apply.</h2>
                <p style={{ marginTop: 12 }}>Learn more about optional fee settings</p>

                <Space direction="vertical" style={{ marginTop: 10 }}>
                    <Checkbox checked={dailyLateFee} onChange={handleDailyLateFee}>I charge daily late fees.</Checkbox>

                    {dailyLateFee ? <>

                        <Space style={{ marginLeft: 26 }}>Tenants are charged a daily late fee of <Input style={{ width: 90, marginLeft: 4, marginRight: 10 }} prefix="$" /></Space>
                        <Space style={{ marginLeft: 26 }}>Daily late fees cannot exceed <Input style={{ width: 90, marginLeft: 4, marginRight: 4 }} prefix="$" />in a month. <i>Leave blank if a limit does not apply.</i></Space>

                    </> : <></>}

                    <Checkbox checked={graceBalance} onChange={handleGraceBalance}>I want to set a grace balance.</Checkbox>

                    {graceBalance ? <>
                        <Space style={{ marginLeft: 26 }}>Tenants will not be charged a late fee until their unpaid balance is over <Input style={{ width: 90, marginLeft: 4, marginRight: 10 }} prefix="$" /></Space>
                    </> : <></>}

                    <Checkbox>I want to charge late fees based on the tenant's entire balance owed, not just this unpaid charge.</Checkbox>

                    <Checkbox>I want to charge late fees based on the charge amount and not the balance owed on the charge.</Checkbox>

                </Space>

            </>
        )
    }

    const ConfirmationContent = () => {
        return (
            <>
                <h2>Step 5: Review</h2>

                <Space direction="vertical" style={{ marginTop: 10 }}>
                    <p>If tenants haven't paid their recurring charges after day 28 of the following month then they will be charged a late fee of ${"100.00"}.</p>
                    <p>Tenants will be charged a daily late fee of ${"100.00"}.</p>
                    <p>Tenants will not be charged a late fee until their unpaid balance is over ${"100.00"}.</p>

                </Space>
            </>
        )
    }


    const steps = [
        {
            title: 'Late Fee Type',
            content: <LateFeeTypeContent />,
        },
        {
            title: 'Eligible Charges',
            content: <EligibleChargesContent />,
        },
        {
            title: 'Grace Period Length',
            content: <GracePeriodLengthContent />,
        }, 
        {
            title: 'Effective Date',
            content: <EffectiveDateContent />,
        }, 
        {
            title: 'Optional Settings',
            content: <OptionalSettingsContent />,
        },
        {
            title: 'Confirmation',
            content: <ConfirmationContent />,
        },
    ];

    const [current, setCurrent] = useState(0);
    const next = () => {
        setCurrent(current + 1);
    };
    const prev = () => {
        setCurrent(current - 1);
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        marginTop: 16,
        padding: 16,
    };

    return (
        <>

            <TopBack label={"Back to " + name} />

            <PageHeading heading={"Late Fee Policy"} />

            <Card title="Late Fee Policy Details">

                <Steps current={current} items={items} labelPlacement="vertical" />
                <div style={contentStyle}>{steps[current].content}</div>
                <div style={{marginTop: 24,}}>

                    {current < steps.length - 1 && (
                        <Button type="primary" onClick={() => next()}>
                            Continue
                        </Button>
                    )}

                    {current === steps.length - 1 && (
                        <Button type="primary" onClick={() => {
                            setPolicyWalkThrough(false)
                            message.success('complete')
                        }}>
                            Update Policy
                        </Button>
                    )}
                    {current > 0 && (
                        <Button
                            style={{
                                margin: '0 8px',
                            }}
                            onClick={() => prev()}
                        >
                            Previous
                        </Button>

                    )}
                    <Button
                        style={{
                            margin: '0 8px',
                        }}
                        onClick={() => setPolicyWalkThrough(false)}
                    >
                        Exit
                    </Button>
                </div>


            </Card>

        </>
    )
}

export default LateFeePolicy